import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory({ basename: '' });
const reactPlugin = new ReactPlugin();

const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production';
const hasInstrumentationKey = process.env.REACT_APP_INSIGHTS && process.env.REACT_APP_INSIGHTS !== '%REACT_APP_INSIGHTS%';

let appInsights = null;

if (isProduction && hasInstrumentationKey) {
    appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: process.env.REACT_APP_INSIGHTS,
            extensions: [reactPlugin],
            extensionConfig: {
              [reactPlugin.identifier]: { history: browserHistory }
            }
        }
    });
    appInsights.loadAppInsights();
    console.log('Application Insights initialized');
} else {
    console.log(`Application Insights skipped (production: ${isProduction}, hasKey: ${hasInstrumentationKey})`);
}

export { reactPlugin, appInsights };